import React from 'react';

const Label = ({text}) =>
{
  return <label>{text}</label>;
}

export default Label;
